var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');
var gsap = require('gsap/ScrollToPlugin');



module.exports = function () {
    function addHandlers(){

			/*anim subtitle*/
			var _mainLogo = document.querySelector('#main-header .main-logo')
			,	_logoPav = document.querySelector('.logo-pav')
			,	bar = document.querySelector('.related-row')
			,	menu = document.querySelector('.menu-prompt')
			,	barTop = document.querySelector('.view-item_header')
			, 	page = document.querySelector('#page')
			,	tlH = new TimelineLite({paused:true})
			,	menuDateTrigger = document.querySelector('.dropdown-date span')
			,	menuDateList = document.querySelector('.dropdown-date-list')
			; 

			/* FAKE SELECT MENU, DATE SELECTION */
			menuDateTrigger.addEventListener('click', function(e){
				e.preventDefault();
				if(this.open){
					TweenLite.to(menuDateList, 0.3, {height:0})
					
				}else{
					
					TweenLite.set(menuDateList, {height:"auto"})
					TweenLite.from(menuDateList, 0.3, {height:0})
					
				}

				this.open = !this.open;
			});
			
			
			if(classList(document.querySelector('body')).contains('candidatures_ef154_list')
				|| classList(document.querySelector('body')).contains('candidatures_ef154')
				|| classList(document.querySelector('body')).contains('candidatures_ef154_fiche')){
					
				tlH.to(_logoPav, .4, {x:'180%' , ease: Power2.easeInOut}) 
				tlH.to(_mainLogo, .5, {x:'-180px', ease: Power2.easeInOut}, "-=0.4")
				
				  
			}else{
				
				tlH.to(_logoPav, .4, {x:'180%' , ease: Power2.easeInOut}) 
				tlH.to(_mainLogo, .5, {x:'-180px', ease: Power2.easeInOut}, "-=0.4")
				
				tlH.to(_mainLogo, .5, {x:'70px', ease: Power2.easeInOut} )
				tlH.to(menu, .3, {x:'0%', ease: Power2.easeInOut}, "-=0.4")
			}
	
			

			pubsub.on('window:scroll', function(scrollY){
				if(scrollY > 200){
					tlH.play()
				}else{
					tlH.reverse()
				}

				if(bar){
					//STICKY RELATION
					
					if (scrollY >= barTop.offsetHeight) {
						page.style.paddingTop = '100px';
						classList(bar).add("sticky");
						
					} else {
						page.style.paddingTop = '0px';
						classList(bar).remove("sticky");
						
					} 
				}
				
			})

			//HOME HEADER SCROLL TO T1
			/*let head = document.querySelector('.b4s3_home .view-item_header.hasVideo');
			if(head){
				head.addEventListener('click', function(){
					TweenMax.to(window, 1.2, {scrollTo:{y : document.querySelector('.bloc.T1')},ease: Power2.easeOut, onComplete : function(){
						
					}});  
				})
			}*/
			
    } 

    addHandlers();


}
